// https://vuex.vuejs.org/en/getters.html

export default {
    getRoleName: state => roleUid => {
      var role = state.list.find(c => {
        return c.uid === roleUid
      })
      return !role ? 'Unknown role' : role.name
    },
  }
